import { groq } from 'next-sanity'
import { flexibleContent, seoFields } from '@otomoro/sanity/lib/queries/partials/shared'

export const impactPageQuery = groq`*[_type == "impactPage" && language == "en"][0] {
  pageTitle,
	headline,
  subHeadline,
  heroImage,
  introduction,
  secondIntro,
  cards,
	${flexibleContent}
  ${seoFields}
}`

export const impactPageSeoQuery = groq`*[_type == "impactPage" && language == "en"][0]{
  ${seoFields}
}`
